var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTraining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4919 22.9321L22.9767 27.1968L20.2229 22.3232H14.7007C13.2428 22.3232 11.9443 23.2455 11.4641 24.6221L5.94506 40.4433C5.1678 42.6715 6.82188 45.0003 9.18171 45.0003H12.9702C12.5949 44.5806 12.3666 44.0264 12.3666 43.419V30.762C12.3666 29.4513 13.4292 28.3888 14.7398 28.3888H36.3622C37.6728 28.3888 38.7353 29.4513 38.7353 30.762V43.419C38.7353 44.0264 38.5071 44.5806 38.1318 45.0003H41.7718C44.1166 45.0003 45.7693 42.6989 45.02 40.4771L39.685 24.6558C39.2149 23.2619 37.9078 22.3232 36.4368 22.3232H30.9555L28.0817 27.1958L25.4919 22.9321ZM14.9743 43.1846V30.9965H36.1277V43.1846H14.9743Z",
    fill: "#E44336"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5258,
    cy: 13.8832,
    r: 7.38324,
    fill: "#E44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.d201735052a57cceb094ca8cd51646d6.svg";
export { ForwardRef as ReactComponent };